export const AUTOMATION = 'automation';
export const CONTACTS = 'contacts';
export const PRICING = 'pricing';
export const COOKIES = 'cookies';
export const FORM = 'form';
export const FEEDBACK = 'feedback';
export const INTRO = 'intro';
